export class CreateListGoods{
    typeWarehousing: number;
    note: string;
}